import React from "react";
import { useObservable } from "micro-observables";

import { isLoadingUrls, urlList } from "../../../services/stepThree";

import styles from "./styles.module.scss";

const UrlList = () => {
    const urls = useObservable(urlList);
    const isLoading = useObservable(isLoadingUrls);

    if(isLoading) {
        return "Loading...";
    }

    return !!urls.length && (
        <div className={styles.normalizers}>
            <div className={styles.titleIdentifiers}>Results: ({urls.length})</div>

            <div className={styles.normalizerList}>
                {
                    urls.map((url, index) => (
                        <div
                            className={styles.normalizerItem}
                            key={index}
                        >
                            <a
                                href={url}
                                title={url}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                {url}
                            </a>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default UrlList;
